module.exports = __webpack_public_path__ + "static/008-b39efdf527e094315c26ae36fa61ef26.jpg";